/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Row, Typography } from "antd";
import React, { useEffect } from "react";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Notification from "../../../components/shared/Notification";
import ManagementPageContainer from "../../components/ManagementPageContainer/ManagementPageContainer";
import styles from "./styles/NotificationTRE.module.css";
import { formatDate } from "../../../helpers/formatDate";

const { Text, Title, Paragraph } = Typography;

const NotificationTREView = () => {
  const navigate = useNavigate();
  const locationData = useLocation().state;
  const { id } = useParams();
  useEffect(() => {
    if (!locationData || !id) {
      Notification("Error", "No page data!", "error");
      navigate(-1);
    }
  }, [locationData, id]);
  return (
    <ManagementPageContainer title={" Notification"}>
      <div className={styles.info}>
        <Row className="fullWidth">
          <Col span={24}>
            <Title className={styles.alignLeft} level={4}>
              {locationData.title}
            </Title>
          </Col>
        </Row>
        <Row className="fullWidth" style={{ marginBottom: "20px" }}>
          <Col span={24}>
            <Paragraph style={{ textAlign: "left" }}>
              {locationData.body}
            </Paragraph>
          </Col>
        </Row>
        <Row className="fullWidth">
          <Col
            span={20}
            style={{ justifyContent: "flex-start", display: "flex" }}
          >
            <Text strong> {formatDate(moment())}</Text>
          </Col>
        </Row>
      </div>
    </ManagementPageContainer>
  );
};

export default NotificationTREView;
